<template>
  <div class="add-visit-person">
    <title-bar
      :title="
        isEdit
          ? $t('Gattaran_0_Edit_contacts_nCLZ' /** 编辑联系人 */)
          : $t('Gattaran_0_Create_new_Faau' /** 新建联系人 */)
      "
      show-back
      @back="back"
    />
    <div
      v-if="!hasNotificationCloseCache && notificationShow"
      ref="notification"
      class="notification"
    >
      <p>
        <i class="icon-outlined_information"></i
        >{{ $t('Gattaran_0_Maximum_number_pgYM' /** 每种角色最多新建一个人 */) }}
      </p>
      <i class="richic-close" @click="closeNotification"></i>
    </div>
    <div class="add-visit-person-list-wrapper">
      <soda-form
        v-if="dataLoaded"
        ref="form"
        v-model="formData"
        class="add-visit-person-form"
        :config="formConfig"
      />
      <soda-form
        v-if="dataLoaded"
        ref="primaryForm"
        v-model="primaryForm"
        class="add-visit-person-primary"
        :config="config"
      />
    </div>
    <div class="save">
      <rich-button class="save-btn" :loading="loading" @click="save">
        <span>{{ gettext('保存') }}</span>
      </rich-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import TitleBar from '@/components/TitleBar'
import SodaForm from '@/components/form/index'
import { mapState } from 'vuex'
import { getVisitObjectInit, saveVisitObject } from '../../service'
import daphne from '@didi/daphne-sdk-javascript'
import ruleConfig from '@/common/utils/rules-COM'
import { i18n, sprintf } from '@/common/utils/i18n'
const nI18n = {
  gettext: i18n.gettext,
  sprintf
}
export default {
  name: 'AddVisitPerson',
  components: {
    TitleBar,
    SodaForm
  },
  props: {
    roleId: {
      required: false,
      type: Number,
      default: 0
    },
    isEdit: {
      required: true,
      type: Boolean
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      loading: false,
      dataLoaded: false,
      primaryContact: [],
      bizoppId: this.$route.query.bizoppId,
      formData: {},
      primaryForm: {},
      visitObjectList: [],
      phonePreText: '',
      notificationShow: true,
      hasNotificationCloseCache: window.localStorage.getItem('add_person_notification_close') === 'true'
    }
  },
  computed: {
    ...mapState(['login']),
    roleList () {
      const list = this.options.roleId?.enum
      return list.length > 0
        ? list.map(i => ({ value: i.value, text: i.label }))
        : []
    },
    contactModeList () {
      return this.options.contactMode.enum
    },
    formConfig () {
      const phoneRule = ruleConfig.telePhone('', nI18n)
      return [
        {
          label: this.$t('Gattaran_0_Role_QDBu' /** 角色 */),
          type: 'rich-select',
          prop: 'roleId',
          props: {
            disabled: this.isEdit,
            options: this.availableRoleList,
            placeholder: this.gettext('请选择')
          },
          rules: {
            required: true
          }
        },
        {
          label: this.gettext('姓名'),
          type: 'input',
          prop: 'name',
          props: {
            placeholder: this.gettext('请输入')
          },
          rules: {
            required: true
          }
        },
        {
          label: this.gettext('电话'),
          type: 'phone',
          prop: 'phone',
          props: {
            placeholder: this.gettext('请输入'),
            preText: this.phonePreText
          },
          rules: {
            required: true,
            pattern: /^\d+$/
          },
          messages: phoneRule.messages
        },
        {
          label: this.$t('Internal_Tools_CRM_jrXd_olfC' /** 最佳拜访时间 */),
          type: 'timeRangePicker',
          prop: 'contactTime',
          props: {
            placeholder: this.gettext('请选择')
          },
          rules: {
            custom: (val) => {
              if (!val[0] || !val[1]) {
                return true
              } else {
                const start = +new Date(`1970/01/01 ${val[0]}`)
                const end = +new Date(`1970/01/01 ${val[1]}`)
                return start < end
              }
            }
          },
          messages: {
            custom: this.$t('Gattaran_0_The_end_KvBf' /** 结束时间必须大于开始时间 */)
          }
        },
        {
          label: this.$t('Internal_Tools_CRM_bNjK_DISV' /** 偏好拜访方式  */),
          type: 'multiSelectNew',
          prop: 'contactMode',
          props: {
            options: this.contactModeList,
            placeholder: this.gettext('请选择')
          }
        }
      ]
    },
    config () {
      return [
      {
          label: this.$t('Internal_Tools_App_dIhB_OKLN' /** 设置为主要联系人吗？ */),
          type: 'rich-radio-group',
          prop: 'isPrimary',
          props: {
            horizontal: true,
            border: false,
            disabled: this.isEdit,
            options: [
              {
                label: this.$t('Internal_Tools_App_WpuB_Tmys' /** 是 */),
                value: 1
              },
              {
                label: this.$t('Internal_Tools_App_skNg_IIIe' /** 否 */),
                value: 0
              }
            ],
            placeholder: this.gettext('请选择')
          },
          rules: {
            required: true
          }
        },
      ]
    },
    availableRoleList () {
      const existedRoleIds = this.visitObjectList.map(i => i.roleId)
      return this.isEdit
        ? this.roleList
        : this.roleList.filter(role => !existedRoleIds.includes(role.value))
    }
  },
  async mounted () {
    const loading = this.$createToast({ mask: true })
    loading.show()
    // 获取callingCode配置
    const { country } = this.login.userInfo
    const callingCode = daphne.getCallingCode(country)
    this.phonePreText = callingCode

    // 获取拜访相关配置
    const initConf = await getVisitObjectInit({ bizoppId: this.bizoppId })
    this.visitObjectList = initConf.visitObjectList || []

    // 编辑页获取拜访详情回显表单
    if (this.isEdit) {
      const contactDetail = this.visitObjectList.find(i => i.roleId === this.roleId)
      this.primaryContact = this.visitObjectList.filter(i => i.isPrimary === 1)
      const { contactModeList=[] } = initConf
      const { name, phone, contactTime = [], contactMode = [], roleId, isPrimary } = contactDetail
      const modeCheck = contactModeList.filter(item=>contactMode.includes(item.key))
      this.formData.roleId = roleId
      this.formData.name = name
      this.formData.phone = phone
      this.formData.contactTime = contactTime && contactTime.length
                                    ? [contactTime[0].startTime, contactTime[0].endTime]
                                    : ['', '']
      this.formData.contactMode = modeCheck.map(i => i.key)
      this.primaryForm.isPrimary = isPrimary
    }

    this.dataLoaded = true
    loading.hide()
  },
  methods: {
    async save () {
      const isValid = await this.$refs.form.validate()
      const isPrimaryFormValid = await this.$refs.primaryForm.validate()
      if (isValid && isPrimaryFormValid) {
        this.loading = true
        const { bizoppId } = this
        const { name, phone, contactTime = ['', ''], contactMode = [], roleId } = this.formData
        const { isPrimary } = this.primaryForm
        const selectedRole = this.roleList.find(role => role.value === roleId) || {}
        const roleDesc = selectedRole.text
        const params = {
          bizoppId,
          roleId,
          roleDesc,
          name,
          phone,
          contactTime: [{
            startTime: contactTime ? contactTime[0] : '',
            endTime: contactTime ? contactTime[1] : ''
          }],
          contactMode,
          isPrimary
        }
        /** 是主要联系人且之前有主要联系人且不是当前的给予提示 */
        const isToast = isPrimary ? this.primaryContact.length === 0 ? false : this.primaryContact[0].roleId !== this.roleId : false
        if (isToast) {
          this.$createToast({
            type: 'correct',
            txt: this.$t('Internal_Tools_App_ttnY_JnyP' /** 主要联系人已更新 */),
            time: 1000
          }).show()
        }
        const res = await saveVisitObject(params)
        this.loading = false
        if (res) {
          this.$emit('save', params)
          this.$emit('back')
        }
      }
    },
    back () {
      this.$emit('back')
    },
    closeNotification () {
      this.notificationShow = false
      window.localStorage.setItem('add_person_notification_close', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-visit-person {
  position: relative;
  background-color: #f2f3f6;
  height: 100%;

  .notification {
    display: flex;
    align-items: center;
    width: 100%;
    background: #e9eaee;
    z-index: 1;
    text-align: left;

    p {
      flex: 1;
      padding: 24px 0 24px 40px;
      font-size: 24px;
      color: #595c66;
      line-height: 32px;
      font-weight: 400;

      .icon-outlined_information {
        margin-right: 6px;
        font-size: 32px;
        vertical-align: middle;
      }
    }

    .richic-close {
      display: flex;
      align-items: center;
      margin: 0 32px;
      flex: 0;
      font-size: 48px;
    }
  }

  &-list-wrapper {
    padding-bottom: 120px;
    background-color: #f2f3f6;
    height: calc(100vh - 100px - 152px);
    box-sizing: border-box;
    overflow: scroll;
  }

  &-form {
    margin: 24px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: #ffffff;

    ::v-deep .rich-form-item {
      padding: 24px;

      .rich-form-label {
        font-size: 24px;
        color: #8d9099;
        line-height: 32px;
        padding-bottom: 16px;
      }
      .rich-form-field {
        font-family: DiDiSans-Pro-Medium;
        font-size: 36px;
        color: #282b33;
        line-height: 44px;
        padding-bottom: 16px;

        .rich-input-wrapper {
          height: auto;
          .rich-input-label-placeholder {
            display: none;
          }
          .rich-input-bottom {
            padding: 0;
          }
        }
      }
    }
  }

  &-primary {
    margin: 24px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: #ffffff;

    ::v-deep .rich-radio-group:after {
      border: none;
    }
    ::v-deep .rich-radio-text {
      text-align: left;
    }
    ::v-deep .border-right-1px:after {
      border-right: none;
    }
  }

  .save {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #ffffff;
    padding: 20px 24px 40px 24px;
    box-sizing: border-box;
    z-index: 999;
    &-btn {
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
